module.exports = {
  serverHostUrl: 'https://server.develop.krispsystems.net',
  accessToken: ''
}
